/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_Type_CompanyInputs */

const vi_order_form_invoice_buyer_type_company = /** @type {(inputs: Order_Form_Invoice_Buyer_Type_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công ty`)
};

/**

* @param {Order_Form_Invoice_Buyer_Type_CompanyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_type_company = /** @type {((inputs?: Order_Form_Invoice_Buyer_Type_CompanyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_Type_CompanyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_type_company(inputs)
});